module.exports = __webpack_public_path__ + "media/packs/images/partners/partner7-b2d736d15d7a5e42c5c517ae7d9d5adb.jpg";